import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { Box } from '@mui/material'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import JourneyMilestones from './pages/JourneyMilestones'
import Interventions from './pages/Interventions'
import Analytics from './pages/Analytics'
import Debug from './pages/Debug'
import AssessmentResults from './pages/AssessmentResults'
// New intervention configuration pages
import Tracks from './pages/Tracks'
import TrackBuilder from './pages/TrackBuilder'
import Domains from './pages/Domains'
import AgentPrompts from './pages/AgentPrompts'
import RiskCodes from './pages/RiskCodes'
import Activities from './pages/Activities'
// Pathway content library pages
import ContentGroups from './pages/ContentGroups'
import Resources from './pages/Resources'
import InformationSources from './pages/InformationSources'
import QolConcerns from './pages/QolConcerns'
import SessionPreview from './pages/SessionPreview'
import UserManagement from './pages/UserManagement'
import AuditLog from './pages/AuditLog'
import AssessmentConfig from './pages/AssessmentConfig'
import InterventionConfigs from './pages/InterventionConfigs'
import InterventionDashboard from './pages/InterventionDashboard'
import PatientAssignments from './pages/PatientAssignments'
import TherapeuticModels from './pages/TherapeuticModels'
import PatientDashboard from './pages/PatientDashboard'
// Education pages
import EducationModules from './pages/EducationModules'
import EducationModuleBuilder from './pages/EducationModuleBuilder'
import EducationModuleView from './pages/EducationModuleView'
// Auth pages
import Login from './pages/Login'
import AuthCallback from './pages/AuthCallback'
// Design exploration (temporary)
import DesignCompare from './pages/DesignCompare'
import { PatientProvider } from './contexts/PatientContext'
import { AuthProvider } from './contexts/AuthContext'
import AuthGuard from './components/auth/AuthGuard'
import ProtectedRoute from './components/auth/ProtectedRoute'

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public routes - outside AuthGuard */}
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/design-compare" element={<DesignCompare />} />

        {/* Protected routes - wrapped in AuthGuard */}
        <Route
          path="/*"
          element={
            <AuthGuard>
              <PatientProvider>
                <Box sx={{ display: 'flex', minHeight: '100vh' }}>
                  <Layout>
                    <Routes>
                      {/* Overview */}
                      <Route path="/" element={<Dashboard />} />
                      <Route path="/dashboard" element={<Dashboard />} />
                      <Route path="/session-preview" element={<SessionPreview />} />

                      {/* Interventions */}
                      <Route
                        path="/intervention-configs"
                        element={
                          <ProtectedRoute resource="intervention_configs" action="read">
                            <InterventionConfigs />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/intervention-dashboard"
                        element={
                          <ProtectedRoute resource="intervention_configs" action="read">
                            <InterventionDashboard />
                          </ProtectedRoute>
                        }
                      />

                      {/* Content Library */}
                      <Route path="/tracks" element={<Tracks />} />
                      <Route path="/tracks/new" element={<TrackBuilder />} />
                      <Route path="/tracks/:id/edit" element={<TrackBuilder />} />
                      <Route path="/domains" element={<Domains />} />
                      <Route path="/content-groups" element={<ContentGroups />} />
                      <Route path="/resources" element={<Resources />} />
                      <Route path="/information-sources" element={<InformationSources />} />
                      <Route path="/qol-concerns" element={<QolConcerns />} />
                      <Route path="/education-modules" element={<EducationModules />} />
                      <Route path="/education-modules/builder/:draftId" element={<EducationModuleBuilder />} />
                      <Route path="/education-modules/:moduleId" element={<EducationModuleView />} />
                      <Route
                        path="/agent-prompts"
                        element={
                          <ProtectedRoute roles="system_admin">
                            <AgentPrompts />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/agent-prompts/:agentType"
                        element={
                          <ProtectedRoute roles="system_admin">
                            <AgentPrompts />
                          </ProtectedRoute>
                        }
                      />

                      {/* Composition Rules */}
                      <Route path="/risk-codes" element={<RiskCodes />} />
                      <Route path="/activities" element={<Activities />} />

                      {/* Assessment Configuration */}
                      <Route path="/assessment-config" element={<AssessmentConfig />} />

                      {/* Patient Management */}
                      <Route path="/patient-dashboard" element={<PatientDashboard />} />
                      <Route
                        path="/patient-assignments"
                        element={
                          <ProtectedRoute resource="intervention_configs" action="read">
                            <PatientAssignments />
                          </ProtectedRoute>
                        }
                      />
                      <Route path="/therapeutic-models" element={<TherapeuticModels />} />
                      <Route path="/journey-milestones" element={<JourneyMilestones />} />
                      <Route path="/assessment-results" element={<AssessmentResults />} />

                      {/* Legacy - keeping for backward compatibility */}
                      <Route path="/interventions" element={<Interventions />} />

                      {/* Analytics */}
                      <Route path="/analytics" element={<Analytics />} />

                      {/* System - Administrator only */}
                      <Route
                        path="/system/users"
                        element={
                          <ProtectedRoute roles="administrator">
                            <UserManagement />
                          </ProtectedRoute>
                        }
                      />
                      <Route path="/system/audit" element={<AuditLog />} />

                      {/* Debug */}
                      <Route path="/debug" element={<Debug />} />
                    </Routes>
                  </Layout>
                </Box>
              </PatientProvider>
            </AuthGuard>
          }
        />
      </Routes>
    </AuthProvider>
  )
}

export default App
